import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";

import './CheckpointPortal.css'

import BreadcrumbItem from "../../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../../component/Page/Page";
import Button from '../../../component/Button/ButtonPortalItem'
import BizLocationSelector from '../../../component/BizLocation/BizLocationSelector'
import CheckpointSelector from '../../../checkpoint/CheckpointSelector'
import PortalService from "../PortalService";
import Notify from "../../../services/Notify";
import MovmentOrderPortalListGrid, { formatStringToCnpj } from "../MovmentOrderPortalListGrid";
import ByondGrid2 from "../../../customGrid/CustomGrid";
import {TransactionStatusItem} from "../../../component/Transaction/TransactionStatusItem";
import Box from "../../../component/Box/Box";
import LoadingV2 from '../../../component/Loading/LoadingV2';
import { InputWithLabel } from '../../../component/Form/InputWithLabel';
import { dayMonthYearAtTimeWithSeconds } from '../../../utils/dates';

const portalService = new PortalService();
const packingListGrid = new MovmentOrderPortalListGrid()

const breadcrumbs = [<BreadcrumbItem key={1} title="Portais" to="/portals"/>, <BreadcrumbItem key={2} title="Iniciar Atividade"/>]

const INTEGRATION_TYPES = {
  MOVEMENT_ORDER: "MOVEMENT_ORDER",
  MOVEMENT_ORDER_POST_TRANSACTION_END: "MOVEMENT_ORDER_POST_TRANSACTION_END"
}

export const CheckpointPortalPage = (props) => {
  
  const {history, match} = props;
  
  const [checkpoint, setCheckpoint] = useState(null);
  const [bizLocation, setBizLocation] = useState(null);
  const [movementOrder, setMovementOrder] = useState(null);
  const [canContinue, setCanContinue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasIntegrationType, setHasIntegrationType] = useState(false);
  const [endpointFilters, setEndpointFilters] = useState({});
  const [endpoint, setEndpoint] = useState(packingListGrid.endpoint);
  
  useEffect(() => {
    const hasBizLocation = (checkpoint && checkpoint.lsd && checkpoint.lsd.bizLocation) || bizLocation;
    const hasMovementOrder = (
      (checkpoint && !checkpoint.integrationType) ||
      (checkpoint && checkpoint.isIntegrated) ||
      (checkpoint && checkpoint.integrationType === INTEGRATION_TYPES.MOVEMENT_ORDER_POST_TRANSACTION_END && movementOrder)
    );
    if (hasBizLocation && hasMovementOrder) {
      setCanContinue(true);
    } else {
      setCanContinue(false)
    }
  }, [checkpoint, bizLocation, movementOrder]);

  useEffect(() => {
    
    if (checkpoint && checkpoint.integrationType === INTEGRATION_TYPES[checkpoint.integrationType]) {
      setHasIntegrationType(true)
    } else {
      setBizLocation(null)
      setMovementOrder(null)
      setHasIntegrationType(false)
    }
  }, [checkpoint])

  useEffect(() => {
    const params = new URLSearchParams({})
    const { movementOrderCode, bizLocationId, rota } = endpointFilters

    movementOrderCode && params.append('code', movementOrderCode)
    bizLocationId && params.append('bizLocationId', bizLocationId)
    rota && params.append('rota', rota)
    // endDate && params.append('endDate', endDate)
    
    setEndpoint(`${packingListGrid.endpoint}?status=PENDING&${params}`)
  }, [endpointFilters])

  const startOperation = async () => {
    try {
      setIsLoading(true);
      setCanContinue(false);
      const readpoint = {id: match.params.readpointId};
      await portalService.startOperation(checkpoint, readpoint, bizLocation, movementOrder);
      history.push({pathname: `/portals/readpoints/${readpoint.id}/transactions`, state: {checkpoint, readpoint, bizLocation}});
    } catch (e) {
      setCanContinue(true);
      Notify.error('Falha ao iniciar operação:', e);
    } finally {
      setIsLoading(false);
    }
  }

  const onMovimentationOrderSelected = (state, row) => {
    const movementOrder = row.original;
    
    if (movementOrder.destination) {
      setBizLocation(movementOrder.destination)
    } else {
      setBizLocation(null)
    }
    
    Notify.success('Ordem selecionada: ' + (movementOrder.code))
    setMovementOrder(movementOrder);
  }

  const MovementOrderDetail = ({ title, content }) => {
    return (
      <div>
        <h4 style={{fontWeight: 'bold'}}>{title}</h4>
        <p>{content}</p>
      </div>
    )
  }

  return (
      <Page title="Portais" breadcrumbs={breadcrumbs}>
        <Box tema="info">
          <Row className="align-items-center">
            <Col sm={8} lg={8} md={8}>
              <CheckpointSelector filter={`?type=DEFAULT&_readpointId=${match.params.readpointId}`} onChange={setCheckpoint}/>
            </Col>
            <Col style={{textAlign: 'right'}} md={3}>
              <LoadingV2 isLoading={isLoading}>
                <Button
                  disabled={!canContinue}
                  onClick={startOperation}
                  className="start-operation-button"
                  text="Iniciar"
                />
              </LoadingV2>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {checkpoint && checkpoint.lsd && !checkpoint.lsd.bizLocation && !hasIntegrationType && <BizLocationSelector defaultValue={bizLocation && bizLocation.id} onChange={setBizLocation}/>}
            </Col>
          </Row>
          {
            hasIntegrationType && (
              <Row className="mt-4 justify-content-center align-items-center">
                <Col md={12}>
                  { hasIntegrationType && <h3>{movementOrder ? 'Ordem de movimentação selecionada' : 'Selecione uma ordem de movimentação'}</h3> }
                </Col>
                <Col md={4}>
                  {movementOrder && <MovementOrderDetail title="Destino" content={movementOrder.destination.friendlyName}/>}
                </Col>
                <Col md={4}>
                  {movementOrder && <MovementOrderDetail title="Tipo viagem" content={movementOrder.tipoRota}/>}
                </Col>
                <Col md={4}>
                  {movementOrder && <MovementOrderDetail title="Rota" content={movementOrder.rota}/>}
                </Col>
                <Col md={4}>
                  {movementOrder && <MovementOrderDetail title="Ordem de Movimentação" content={movementOrder.code}/>}
                </Col>
                <Col md={4}>
                  {movementOrder && <MovementOrderDetail title="CNPJ" content={formatStringToCnpj(movementOrder.destination.erpCode)}/>}
                </Col>
                <Col md={4}>
                  {movementOrder && <MovementOrderDetail title="Data Doc" content={movementOrder.createdAt && dayMonthYearAtTimeWithSeconds(movementOrder.createdAt)}/>}
                </Col>
              </Row>
            )
          }
        </Box>
        {hasIntegrationType && 
          <Box title="Selecione a ordem de movimentação">
            <Row className="p-4">
              <Col md={4}>
                <InputWithLabel 
                  label="Operação" 
                  placeholder="Digite a operação"
                  inputType="number"
                  onlyNumbers
                  value={endpointFilters.rota}
                  onChangeText={e => setEndpointFilters({ ...endpointFilters, rota: e })}
                />
              </Col>
              <Col md={4}>
                <InputWithLabel 
                  label="Ordem de movimentação" 
                  placeholder="Digite o código da ordem de movimentação" 
                  onChangeWithDelay={e => setEndpointFilters({ ...endpointFilters, movementOrderCode: e })}
                />
              </Col>
              <Col md={4}>
                <BizLocationSelector onChange={e => setEndpointFilters({  ...endpointFilters, bizLocationId: e && e.id })}/>
              </Col>
              {/* <Col md={4}>
                <DateRangeSelector onChange={(startDate, endDate) => setEndpointFilters({  ...endpointFilters, startDate: startDate && startDate.toISOString(), endDate: endDate && endDate.toISOString() })}/>
              </Col> */}
            </Row>
            <ByondGrid2 onClickInRow={onMovimentationOrderSelected} removeBox selectRow endpoint={endpoint} match={match} {...props} metadata={packingListGrid}defaultSort={packingListGrid.defaultSort}/>
          </Box>
        }
      </Page>);

}



// WEBPACK FOOTER //
// ./src/pages/PortalPage/CheckpointPortalPage/CheckpointPortal.js